import { extendObservable } from "mobx";
import { IAssunto } from "../Assunto";
import { ClasseJudicial } from "../dominio/ClasseJudicial";
import { Partes } from "../dominio/Partes";
import { Peca } from "../dominio/Peca";
import { Relator } from "../dominio/Relator";
import { IIndicadores } from "../Indicadores";
import { IMovimento } from "../Movimento";
import { AlertaDto } from "./AlertaDto";
import { ClasseJudicialDto } from "./ClasseJudicialDto";
import { OrgaoJulgadorCargo } from "./OrgaoJulgadorCargo";
import { OrgaoJulgadorDto } from "./OrgaoJulgadorDto";
import { TarefasFluxoDto } from "./TarefasFluxoDto";
import { Processo } from "../Processo";
import { EnumOrigemProcesso, OrigemProcesso } from "../OrigemProcesso";
import NumeroProcesso from "../../utils/NumeroProcesso";
import { ProcessoAssociado, ProcessoComCorreJunto } from "../ProcessoRelacionamentos";

export class DadosProcessoDto {

    numero: string;
    classesJudicial: ClasseJudicialDto[];
    relator: Relator;
    orgaoJulgador: OrgaoJulgadorDto;
    orgaoJulgadorCargo: OrgaoJulgadorCargo;
    orgaoJulgadorColegiado: OrgaoJulgadorDto;
    autuadoEm: string;
    id: number;
    valorDaCausa: number;

    partes: Partes;
    mensagemErroPartes?: string;
    origem: string;

    classeJudicial: ClasseJudicialDto;
    identificadorProcesso?: number;
    movimentos?: IMovimento[];
    assuntoList?: IAssunto[];
    indicadores?: IIndicadores[];
    alertas?: AlertaDto[];
    tarefaFluxoPje?: TarefasFluxoDto;
    pecas?: Peca[];
    alertasAtivos?: AlertaDto[];
    dataAutuacaoTst?: string;
    sigUnAdm?: string;
    processosAssociados?: ProcessoAssociado[];
    correJuntos?: ProcessoComCorreJunto[];

    static mobxInicial = () => ({
        classeJudicial: undefined,
        movimentos: [],
        assuntoList: [],
        indicadores: [],
        alertas: [],
        pecas: [],
        processosAssociados: [],
        correJuntos: []
    })

    public static novo(dadosProcessoDto: Partial<DadosProcessoDto>) {

        if (!dadosProcessoDto) {
            dadosProcessoDto = {};
        }

        const dadosProcesso = new DadosProcessoDto();
        const mobxInicial = DadosProcessoDto.mobxInicial();
        extendObservable(dadosProcesso, mobxInicial);

        return Object.assign(dadosProcesso, dadosProcessoDto);
    }

    public static toProcesso(dadosProcesso: DadosProcessoDto, processo : Processo){
        processo.identificadorProcesso = dadosProcesso.id || dadosProcesso.identificadorProcesso;
        const classe = dadosProcesso.classesJudicial?.map(classe => classe.sigla).join('-') || dadosProcesso.classeJudicial?.sigla || '';
        processo.numeroProcesso = classe && NumeroProcesso.isValido(dadosProcesso.numero)
            ? `${classe} - ${NumeroProcesso.valueOf(dadosProcesso.numero).semFase().numeroProcessoFormatado()}`
            : processo.numeroProcesso;
        processo.numero = dadosProcesso.numero;
        processo.classeJudicial = dadosProcesso.classeJudicial
            || ClasseJudicial.novoComArray(dadosProcesso.classesJudicial);
        processo.orgaoJulgador = dadosProcesso.orgaoJulgador;
        processo.orgaoJulgadorColegiado = dadosProcesso.orgaoJulgadorColegiado;
        processo.autuadoEm = dadosProcesso.autuadoEm || dadosProcesso.dataAutuacaoTst;
        processo.dataAutuacaoTst = dadosProcesso.dataAutuacaoTst;
        processo.movimentos = dadosProcesso.movimentos;
        processo.tarefaFluxoPje = dadosProcesso.tarefaFluxoPje;
        processo.processosAssociados = dadosProcesso.processosAssociados || [];
        processo.correJuntos = dadosProcesso.correJuntos || [];
        if (dadosProcesso.relator) {
            if (typeof processo.setRelator === 'function') {
                processo.setRelator(dadosProcesso.relator);
            } else {
                processo.relator = dadosProcesso.relator;
            }
        }
        if (dadosProcesso.sigUnAdm) {
            processo.sigUnAdm = dadosProcesso.sigUnAdm;
        }
        processo.origemProcesso = dadosProcesso.origem
            ? {
                id: dadosProcesso.origem as OrigemProcesso,
                descricao: dadosProcesso.origem === EnumOrigemProcesso.PJE ? 'PJe' : 'Legado'
            }
            : processo.origemProcesso;
        return processo;
    }
}
